import { render, staticRenderFns } from "./PlayersEventAccessBlocking.vue?vue&type=template&id=517a3fbe&"
import script from "./PlayersEventAccessBlocking.vue?vue&type=script&lang=js&"
export * from "./PlayersEventAccessBlocking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports